import './zoom-slider.scss';
import './zoom-loader';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/zoom/index.js